import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  createMemoryRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import { getConfigAsync } from './config';
import { logDebug } from './logger';

export async function initSentry() {
  if (Sentry.isInitialized()) {
    return;
  }

  const dsn = await getConfigAsync('SENTRY_DSN');
  const env = await getConfigAsync('ENV');
  const release = process.env.REACT_APP_COMMIT_SHA;

  logDebug('initSentry', { dsn, env, release });

  Sentry.init({
    environment: env,
    enabled: env !== 'local',
    dsn,
    release,
    integrations: [
      Sentry.moduleMetadataIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['resource-hub-ui'],
        behaviour: 'drop-error-if-contains-third-party-frames',
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: 1.0,
  });
}

export async function closeSentry(timeout = 2000) {
  await Sentry.close(timeout);
}

export function makeRouterFunction() {
  const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createMemoryRouter);
  return sentryCreateBrowserRouter;
}
